module.exports = __webpack_public_path__ + "static/media/autohandel.e8100d4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/logos/autohandel.png
// module id = 209
// module chunks = 0